var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"back",on:{"click":function($event){return _vm.goBack()}}},[_c('Icon',{staticClass:"icon",attrs:{"type":"ios-arrow-dropleft","size":"20"}})],1),_c('div',{staticClass:"provinceCharts",attrs:{"id":_vm.id},on:{"mouseleave":_vm.mouseleave}})])
}
var staticRenderFns = []

export { render, staticRenderFns }